import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SocialService } from "src/app/social/social.service";
import { DATE_FORMATS } from "../../services/utils";
import { debounceTime } from "rxjs/operators";
import { Subject } from "rxjs";
import { GlobalVariable } from "src/app/app.component";
import { CommonService } from "src/app/services/common.service";
import moment from "moment";
import { AlertService } from "src/app/services/alert.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { ExpiryWarningService } from "src/app/services/expiry/expiry-warning.service";

@Component({
  selector: "app-review-social-share",
  templateUrl: "./review-social-share.component.html",
  styleUrls: ["./review-social-share.component.scss"],
})
export class ReviewSocialShareComponent implements OnInit {
  @Input() isFromReview: boolean = false;
  @Output() modalCloseClick = new EventEmitter<boolean>();

  loading: boolean = false;
  isProductExpired: boolean = false;
  DATE_FORMATS = DATE_FORMATS;
  page = 1;
  // itemsPerPage = GlobalVariable.ITEMS_PER_PAGE;
  itemsPerPage = 10;
  itemsPerPageList: any = GlobalVariable.ITEMS_PER_PAGE_LIST;
  totalCount = 0;
  reviews = [];
  allowedReviewsCount = 0;
  selectedReviews = [];
  minDate = null;
  maxDate = null;
  dateRange = null;
  nextReviewTime: string = "";
  searchText: string = "";
  searchUpdate = new Subject<string>();
  reviewPermissions: any = null;

  constructor(
    private alertService: AlertService,
    private commonService: CommonService,
    private expiryWarningService: ExpiryWarningService,
    private router: Router,
    private socialService: SocialService,
    private toastService: ToastrService
  ) {
    this.searchUpdate.pipe(debounceTime(500)).subscribe((value) => {
      this.onFilterData();
    });
  }

  ngOnInit(): void {
    this.socialService
      .checkFeatureValue("social_review_share_value")
      .then((response: any) => {
        if (response?.Post) {
          this.allowedReviewsCount = response.Post;
        }
      });
    let { start, end } = this.getStartAndEnd(this.DATE_FORMATS.yearFirst);
    this.minDate = start;
    this.maxDate = end;
    this.dateRange = [new Date(this.minDate), new Date(this.maxDate)];
    this.checkExpiry();
    this.getReviews(true);
  }

  checkExpiry() {
    const { isExpired, expiryWarningText } =
      this.expiryWarningService.checkExpiryBasedOnProductWithoutDialog(
        "REVIEWS"
      );
    this.isProductExpired = isExpired;
  }

  getReviews(isFirstTime: boolean = false) {
    this.loading = true;
    let setFilter = {
      page: this.page.toString(),
      size: this.itemsPerPage.toString(),
      keyword: this.searchText ? this.searchText : null,
      start_date: moment(new Date(this.dateRange[0])).format(
        this.DATE_FORMATS.yearFirst
      ),
      end_date: moment(new Date(this.dateRange[1])).format(
        this.DATE_FORMATS.yearFirst
      ),
    };
    this.socialService.getReviewForSharing(setFilter).subscribe(
      (data: any) => {
        this.getReviewShareMetaData();
        this.reviews = data.data.reviews;
        this.totalCount = data.data.total_reviews;
        this.reviewPermissions = data.data.review_permissions;
        this.reviews = this.reviews.map((review) => {
          // if (!this.isLimitReached() && review?.review_share_id) {
          //   review.isSelected = true;
          //   let data = { review_id: review.id, review_platform: review.source };
          //   this.selectedReviews.push(data);
          // }

          // // keep previous selected reviews status
          // const alreadySelectedReviewIndex = this.selectedReviews.findIndex(
          //   (obj) => obj.review_id === review.id
          // );
          // if (alreadySelectedReviewIndex != -1) {
          //   review.isSelected = true;
          // }
          if (isFirstTime) {
            if (!this.isLimitReached() && review?.review_share_id) {
              review.isSelected = true;
              let data = {
                review_id: review.id,
                review_platform: review.source,
              };
              this.selectedReviews.push(data);
            }
          } else {
            const alreadySelectedReviewIndex = this.selectedReviews.findIndex(
              (obj) => obj.review_id === review.id
            );
            if (alreadySelectedReviewIndex != -1) {
              review.isSelected = true;
            } else {
              review.isSelected = false;
            }
          }
          return review;
        });
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  getReviewShareMetaData() {
    this.socialService.getReviewShareMetaData().subscribe(
      (data: any) => {
        this.nextReviewTime = data.data?.post_share_date_time;
      }
      // (error) => {
      //   this.loading = false;
      // }
    );
  }

  goToEditSetup() {
    // add redirection link to the setup
    this.closeModal();
    this.router.navigate(["/settings/social"]);
    this.commonService.settingsSocialTab.next(3);
  }

  getStartAndEnd(format: typeof DATE_FORMATS.yearFirst) {
    let { today, priorDate } = this.commonService.getPriorDateToCurrentDate(90);
    let start = moment(priorDate).format(format);
    let end = moment(today).format(format);
    return { start, end };
  }

  onFilterData() {
    this.page = 1;
    this.getReviews();
  }

  onReset() {
    this.searchText = "";
    this.dateRange = [new Date(this.minDate), new Date(this.maxDate)];
    this.onFilterData();
  }

  itemsPerPageChange() {
    this.page = 1;
    this.onPageChange(this.page);
  }

  onPageChange($event) {
    this.page = $event;
    this.getReviews();
  }

  isLimitReached() {
    return this.selectedReviews.length >= this.allowedReviewsCount;
  }

  closeModal() {
    this.modalCloseClick.emit(true);
  }

  onSelectAllReviews() {
    this.reviews = this.reviews.map((review) => {
      if (!this.isLimitReached() && !review?.isSelected) {
        review.isSelected = true;
        let data = { review_id: review.id, review_platform: review.source };
        this.selectedReviews.push(data);
      }
      return review;
    });
  }

  onSelectReview(isSelected, review) {
    if (isSelected) {
      review.isSelected = true;
      let data = { review_id: review.id, review_platform: review.source };
      this.selectedReviews.push(data);
    } else {
      const indexOfId = this.selectedReviews.findIndex(
        (obj) => obj.review_id === review.id
      );
      if (indexOfId > -1) {
        this.selectedReviews.splice(indexOfId, 1);
        review.isSelected = false;
      }
    }
  }

  confirmSelection() {
    if (this.selectedReviews.length) {
      this.alertService
        .comfirmationAlert(
          "Save Reviews",
          "Do you want to save selected reviews to post on social?",
          "Save"
        )
        .then((data) => {
          if (data.isConfirmed) {
            this.saveReviewForAutoShare();
          }
        });
    } else {
      this.closeModal();
    }
  }

  saveReviewForAutoShare() {
    this.loading = true;
    let payload = {
      selected_reviews: this.selectedReviews,
    };

    this.socialService.addReviewsToSocialShare(payload).subscribe(
      (data: any) => {
        this.loading = false;
        this.selectedReviews = [];
        this.closeModal();
        this.toastService.success(data.data.message);
      },
      (error) => {
        console.log("addReviewsToSocialShare error ==>>", error);
        this.loading = false;
      }
    );
  }
}
